var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransmissionLoss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9024 12.7081V11.1609H15.9909V12.2052H17.0351V9.40666L13.6414 7.90124L10.5957 5.44385L7.37607 8.04047L4.15639 9.3997V11.509H5.20061V11.1609H7.28905V12.7081L2.7641 14.0552V16.9042H3.80832V15.8599H7.01233L5.84803 20.0368H3.98235V21.081H17.2091V20.0368H15.3435L14.1792 15.8599H17.3832V16.9042H18.4274V14.0552L13.9024 12.7081ZM12.8582 8.72444V10.1167H8.33327V8.76969L12.8582 8.72444ZM15.9909 10.1167H13.9024V9.15953L15.9909 10.0854V10.1167ZM11.7061 7.68022H9.48539L10.5957 6.78393L11.7061 7.68022ZM5.20061 10.1167V10.0924L7.28905 9.21174V10.1167H5.20061ZM12.8582 11.1609V12.3966L8.33327 12.3792V11.1609H12.8582ZM8.33327 14.8157V13.4861H12.8582V14.8157H8.33327ZM3.86923 14.8157L7.28905 13.7976V14.8157H3.86923ZM8.80142 20.0368L10.6149 18.7611L12.4266 20.0368H8.80142ZM14.2592 20.0368L10.6149 17.4837L6.94098 20.0368L8.10528 15.8599H13.0949L14.2592 20.0368ZM13.9024 14.8157V13.7976L17.3223 14.8157H13.9024Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.566,
    y: 3.44385,
    width: 6,
    height: 2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmissionLoss);
export default __webpack_public_path__ + "static/media/transmission-loss.d0b2a9060c11462bbb54387b7eff2ef6.svg";
export { ForwardRef as ReactComponent };